import React from 'react';
import { FormField, Input, InputAdornment, Suggest } from '@cian/ui-kit';
import { IconActionChevronDownSmall16, IconActionChevronUpSmall16 } from '@cian/ui-kit-design-tokens/icons';
import { getFieldPlaceholder } from '../../utils/getFieldPlaceholder';
import { useSuggestField } from '../../hooks/useSuggestField';
import { type IField } from '../../types/calculator';

export const SuggestField: React.FC<IField> = props => {
  const {
    inputValue,
    name,
    label,
    placeholder,
    disabled,
    isError,
    error,
    isSuggestOpen,
    handleSuggestSelect,
    handleSuggestClose,
    handleInputFocus,
    handleInputChange,
    suggestions,
  } = useSuggestField(props);

  const inputAdornment = (
    <InputAdornment>
      {isSuggestOpen ? (
        <IconActionChevronUpSmall16 onClick={handleSuggestClose} color="icon-main-default" />
      ) : (
        <IconActionChevronDownSmall16 onClick={handleInputFocus} color="icon-main-default" />
      )}
    </InputAdornment>
  );

  return (
    <FormField
      label={label}
      errorMessage={isError ? error : undefined}
      required={!!props.validation?.required}
      withoutMargin
    >
      <Suggest
        suggestions={suggestions}
        onSelect={handleSuggestSelect}
        onClose={handleSuggestClose}
        open={isSuggestOpen}
        emptyListText="Ничего не найдено"
        highlightValue={inputValue}
      >
        <Input
          placeholder={getFieldPlaceholder(placeholder)}
          value={String(inputValue)}
          invalid={Boolean(isError && error)}
          name={name}
          disabled={disabled}
          onChange={handleInputChange}
          onFocus={handleInputFocus}
          size="M"
          rightAdornment={inputAdornment}
        />
      </Suggest>
    </FormField>
  );
};

SuggestField.displayName = 'SuggestField';
